import Card from '~/components/Card'
import Icon from '~/components/Icon'
import Input from '~/components/Input'
import Select from '~/components/Select'
import type { TabPagosProps } from './types'

/** Pestaña Pagos: cuenta de cobro por defecto con la que sale el PDF. */
function TabPagos(props: TabPagosProps) {
  const { form } = props

  return (
    <Card>
      <Card.Title>
        <div class="flex items-center">
          <Icon icon="material-symbols-light:account-balance-outline" size={20} class="mr-2" />
          <h2 class="text-xl font-semibold">Cuentas de cobro y datos de pago</h2>
        </div>
      </Card.Title>
      <Card.Body>
        <p class="text-sm text-foreground-subtle mb-4">Con estos datos sale el PDF de la cuenta de cobro y el cliente sabe dónde consignar. Cada cuenta puede sobreescribirlos si es necesario.</p>

        <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <Input name="paymentBankName" label="Banco" placeholder="Bancolombia, Davivienda..." />
          <Select
            name="paymentAccountType"
            label="Tipo de cuenta"
            value={(form.values().paymentAccountType as string) ?? ''}
            placeholder="Selecciona..."
            clearable
            options={[
              { value: 'Ahorros', title: 'Cuenta de ahorros' },
              { value: 'Corriente', title: 'Cuenta corriente' },
              { value: 'Otro', title: 'Otro' }
            ]}
          />
          <Input name="paymentAccountNumber" label="Número de cuenta" placeholder="000-123456-78" />
          <Input name="paymentAccountHolder" label="Titular de la cuenta" placeholder="Nombre o razón social" />
          <Input name="paymentHolderDocument" label="Documento del titular" placeholder="NIT, cédula..." />
        </div>
      </Card.Body>
    </Card>
  )
}

export default TabPagos
